import React from 'react';

import { RouteObject } from 'react-router-dom';

import { UserPermissions } from '@/features/permissions';

const CounterpartyInformation = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/Information'),
);

const CounterpartyAccountLedger = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/Ledger'),
);

const CounterpartyAccountDebtDynamics = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/DebtDynamics'),
);

const CounterpartyActsAndInvoices = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/ActsAndInvoices'),
);

const CounterpartyPnl = React.lazy(
  () => import('@/pages/CounterpartyDetails/views/Pnl'),
);

export const counterpartyDetailPath = {
  Information: '',
  Ledger: 'ledger',
  DebtDynamics: 'debt-dynamics',
  ActsAndInvoices: 'acts-and-invoices',
  Pnl: 'pnl',
};

export const counterpartyDetailRoutes: RouteObject[] = [
  { index: true, element: <CounterpartyInformation /> },
  {
    path: counterpartyDetailPath.Ledger,
    element: <CounterpartyAccountLedger />,
  },
  {
    path: counterpartyDetailPath.DebtDynamics,
    element: <CounterpartyAccountDebtDynamics />,
  },
  {
    path: counterpartyDetailPath.ActsAndInvoices,
    element: <CounterpartyActsAndInvoices />,
    handle: {
      permissions: UserPermissions.OrganizationsActsAndInvoicesRead,
    },
  },
  {
    path: counterpartyDetailPath.Pnl,
    element: <CounterpartyPnl />,
  },
];
